<template>
  <Flex
    align="start"
    :gap="0"
    v-test="'register-payment-service-package'"
  >
    <div :class="$style.number">
      <BaseText>{{ quantity }}</BaseText>
    </div>
    <Flex
      direction="column"
      :gap="0.25"
      grow
    >
      <Flex
        wrap
        align="center"
        :gap="0.5"
      >
        <BaseText v-test="'register-payment-service-package-name'">
          {{ name }}
        </BaseText>
        <BaseText
          v-if="discountPercentage"
          color="secondary"
          v-test="'register-payment-service-package-discount'"
        >
          {{ `(${discountPercentage}% ${$t('global.discount')})` }}
        </BaseText>
      </Flex>
      <BaseText
        v-for="(serviceName, index) in serviceNames"
        :key="index"
        color="secondary"
        size="s"
        v-test="'register-payment-service-package-service'"
      >
        {{ serviceName }}
      </BaseText>
    </Flex>
    <Flex
      align="center"
      :gap="0.5"
    >
      <BaseText
        v-if="originalPrice !== price"
        lineThrough
        inline
        v-test="'register-payment-service-package-original-price'"
      >
        {{ filters.currency(originalPrice) }}
      </BaseText>
      <BaseText v-test="'register-payment-service-package-price'">
        {{ filters.currency(price) }}
      </BaseText>
    </Flex>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import filters from '@/filters';

defineProps<{
  name: string;
  serviceNames: string[];
  quantity: number;
  price: number;
  originalPrice: number;
  discountPercentage: number;
}>();
</script>

<style
  lang="scss"
  module
>
.number {
  min-width: 30px;
}
</style>
